export enum DiseasesRadioGroupId {
  HIGHLIGHT_INTENSITY_SEVERITY = 337373
}

export enum DiseasesRadioGroupExpressions {
  HIGHLIGHT_INTENSITY_SEVERITY = 'highlightIntensitySeverity',
}

export enum DiseasesHighlightIntensitySeverityId {
  MILD_LITTLE          = 'L',
  MEDIUM_MODERATE      = 'M',
  SEVERE_LARGE         = 'I',
}
